var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollarBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#E72649"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 9.577C11.25 10.862 10.207 11.715 8.667 11.8435V13H7.612V11.832C6.57034 11.7145 5.58064 11.3144 4.75 10.675L5.526 9.612C6.2175 10.1495 6.872 10.5 7.6605 10.617V8.327C5.89 7.883 5.0655 7.2405 5.0655 5.9205C5.0655 4.659 6.096 3.7945 7.612 3.6775V3H8.667V3.701C9.49156 3.79259 10.2777 4.09877 10.947 4.589L10.2675 5.687C9.734 5.3015 9.1885 5.056 8.6185 4.9395V7.159C10.462 7.603 11.25 8.3155 11.25 9.577V9.577ZM7.66 6.9135V4.8575C6.8965 4.916 6.4965 5.325 6.4965 5.839C6.4965 6.329 6.7265 6.645 7.6605 6.914L7.66 6.9135ZM9.819 9.6585C9.819 9.1335 9.564 8.818 8.6185 8.549V10.664C9.3825 10.605 9.819 10.2195 9.819 9.659V9.6585Z",
    fill: "#1A1C22"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarBlack);
export default __webpack_public_path__ + "static/media/dollar-black.c0cb9e4b96fb1bedfa71c0b2beacc4e5.svg";
export { ForwardRef as ReactComponent };